import React from "react";
import PageHeader from "./PageHeader.js";
import PageFooter from "./PageFooter.js";
import axios from "axios";
import loaderImage from "../static/loader.svg";
import Dialog from "rc-dialog";
import "rc-dialog/assets/bootstrap.css";
import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";
import { detect } from "detect-browser";

import * as Sentry from "@sentry/browser";
import cx from "classnames";

const sentry_key = APP_CONFIG.sentry_key;
const sentry_app = APP_CONFIG.sentry_app;
const sentry_environment = APP_CONFIG.sentry_env;
const browser = detect();

if (sentry_key && sentry_app) {
    Sentry.init({
        dsn: "https://" + sentry_key + "@sentry.io/" + sentry_app,
        environment: sentry_environment
    });
}

const google_analytics_id = APP_CONFIG.google_analytics_id;
let lastPage = "";

if (google_analytics_id) {
    ReactGA.initialize(google_analytics_id);
}

const hotjar_id = APP_CONFIG.hotjar_id;
if (hotjar_id) {
    hotjar.initialize(hotjar_id, "");
}

// Check the browser first, redirect to a page if this browser is not suported
if (browser && !window.location.href.includes("outdated")) {
    let redirect = false;
    if (browser.name == "ie") {
        redirect = true;
    }
    if (browser.name == "ios" && parseInt(browser.version) < 10) {
        redirect = true;
    }

    if (redirect) {
        window.location = "/outdated";
    }
}

export default class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            globalErrorTitle: "",
            globalErrorContent: "",
            globalErrorVisible: false
        };
    }

    componentDidMount() {
        axios.defaults.validateStatus = (status) => {
            if (status >= 500) {
                // Fatal error, give an alert for the user so they at least see something went terribly wrong
                this.setState({
                    globalErrorTitle: "Fatale fout",
                    globalErrorContent: (
                        <div>
                            Er ging iets fout bij het uitvoeren van uw verzoek. <br />
                            Als dit probleem zich voor blijft doen neem dan contact op met NIBHV.
                        </div>
                    ),
                    globalErrorVisible: true
                });
                return false;
            } else if (status === 404) {
                // The requested item could not be found
                this.setState({
                    globalErrorTitle: "Het opgevraagde item kon niet worden gevonden",
                    globalErrorContent: <div>Je hebt niet voldoende rechten om deze actie uit te mogen voeren of dit item bestaat niet meer.</div>,
                    globalErrorVisible: true
                });
                return false;
            } else if (status === 403) {
                // The current user lacks the specific rights to do this
                this.setState({
                    globalErrorTitle: "Je hebt geen rechten om dit te doen",
                    globalErrorContent: (
                        <div>
                            Je hebt niet voldoende rechten om deze actie uit te mogen voeren.
                            <br />
                            Als je ervan overtuigd bent dat dit wel het geval zou moeten zijn, neem dan contact op met NIBHV.
                        </div>
                    ),
                    globalErrorVisible: true
                });
                return false;
            } else if (status === 401 && this.props.isLoggedIn) {
                // We are not logged in anymore
                // todo: shouldn't we dispatch logout()?
                localStorage.clear();
                window.location = "/";
                return true;
            } else if (status === 400) {
                // Something went wrong with the request, we have feedback in the request itself
                return false;
            }
            return true;
        };
    }

    componentDidUpdate() {
        let newPage = window.location.pathname + window.location.search;
        if (newPage !== lastPage) {
            lastPage = newPage;
            if (google_analytics_id) {
                ReactGA.pageview(lastPage);
            }
        }
    }

    hideWarning = () => {
        this.setState({
            globalErrorVisible: false
        });
    };

    render() {
        let dialog = (
            <Dialog
                title={this.state.globalErrorTitle}
                onClose={this.hideWarning}
                visible={this.state.globalErrorVisible}
                animation="fade"
                footer={[
                    <button type="button" className="btn btn-primary" key="no" onClick={this.hideWarning}>
                        Sluiten
                    </button>
                ]}
            >
                {this.state.globalErrorContent}
            </Dialog>
        );

        return (
            <div className={cx("site-container", this.props.userSettings?.snugFit && "site-container--compact")}>
                <PageHeader {...this.props} />

                <div className="main-container">{React.cloneElement({ ...this.props }.children, { ...this.props })}</div>

                <PageFooter loggedIn={!!this.props.isLoggedIn} />

                {this.state.loading ? (
                    <div className="loader-global">
                        <img src={loaderImage} alt="Loader" />
                    </div>
                ) : (
                    ""
                )}

                {dialog}
            </div>
        );
    }
}
